import { connect } from 'react-redux';
import {
  getFilterIdentifierCount,
  resetCardFilters,
} from 'feature/loading-management/filters/store/filtersSlice';
import CardsPanel from './CardsPanel';
import {
  getCardsToDisplay,
  getCurrentSelection,
  setActiveMyAuthTab,
  setFiltersOpen,
} from '../store/myAuthorizationsSlice';

const mapState = state => ({
  activeMyAuthTab: state.loadingManagement.myAuthorizations.activeMyAuthTab,
  currentSelection: getCurrentSelection(state),
  filterIdentifierCount: getFilterIdentifierCount(state),
  filtersOpen: state.loadingManagement.myAuthorizations.filtersOpen,
  myAuthorizationCards: getCardsToDisplay(state),
  myAuthorizationPending: state.loadingManagement.myAuthorizations.myAuthorizationPending,
  // only used in List Tabs to calculate values, myAuthorizationCards is always an array
  myAuthorizations: state.loadingManagement.myAuthorizations.myAuthorizationCards,
  selectorsListPending: state.loadingManagement.myAuthorizations.selectorsListPending,
});

const mapDispatch = {
  resetCardFilters,
  setActiveMyAuthTab,
  setFiltersOpen,
};

export default connect(mapState, mapDispatch)(CardsPanel);
